/**
 * Check if browser supports Web Share API
 */
const shareIsSupported = () => {
  if (navigator.share) {
    return true
  }
  return false
}

/**
 * Trigger native browser share
 *
 * @param {String} title
 * @param {String} text
 * @param {String} url
 * @param {Fn} callback Optional callback function
 */
const triggerWebShare = (title, text, url, callback = null) => {
  if (navigator.share) {
    navigator
      .share({
        text,
        title,
        url
      })
      .then(() => {
        if (callback) {
          callback()
        }
      })
      .catch(err => {
        if (callback) {
          callback(err)
        }
      })
  } else {
    console.error("web share is not supported")
  }
}

const WebShareApi = {
  shareIsSupported,
  triggerWebShare
}

export default WebShareApi
